module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-16.7ece819e.png";